
    // --- Store Data ---
    const locatorStores = [
      { name: "Aakruti — MG Road, Khammam", address: "MG Road, Near Bus Stand, Khammam", city: "KHAMMAM", distance: "0.3 km", phone: "8341325433", state: "Telangana", zip: "507001", openStatus: true, openTime: "Closes 9:30 PM" },
      { name: "Aakruti — Tank Bund Road, Khammam", address: "Opposite Lake View Garden, Khammam", city: "KHAMMAM", distance: "2.1 km", phone: "040-2999996", state: "Telangana", zip: "507003", openStatus: false, openTime: "Opens 10 AM" },
      { name: "Aakruti — Gachibowli, Hyderabad", address: "Plot No 1-74/DH/186, Gachibowli Main Road", city: "HYDERABAD", distance: "1.4 km", phone: "8341325433", state: "Telangana", zip: "500032", openStatus: true, openTime: "Closes 10 PM" },
      { name: "Aakruti — Kukatpally (KPHB)", address: "MIG-2, 9th Phase, KPHB Colony", city: "HYDERABAD", distance: "3.6 km", phone: "040-2999996", state: "Telangana", zip: "500072", openStatus: true, openTime: "Closes 10 PM" },
      { name: "Aakruti — Moghalrajpuram, Vijayawada", address: "JC Plaza, Jemmi Chettu Street, Vijayawada", city: "VIJAYAWADA", distance: "0.8 km", phone: "0866-2499996", state: "Andhra Pradesh", zip: "520010", openStatus: true, openTime: "Closes 9:30 PM" },
      { name: "Aakruti — Hanamkonda, Warangal", address: "Main Road, Opp Public Gardens, Hanamkonda", city: "WARANGAL", distance: "1.2 km", phone: "8341325433", state: "Telangana", zip: "506001", openStatus: true, openTime: "Closes 9 PM" },
      { name: "Aakruti — Arundelpet, Nellore", address: "Nellore Main Road, Arundelpet", city: "NELLORE", distance: "0.5 km", phone: "8341325433", state: "Andhra Pradesh", zip: "524001", openStatus: true, openTime: "Closes 9:30 PM" },
      { name: "Aakruti — Main Bazaar, Rajahmundry", address: "Main Road, Near Gadiyaram Tower, Rajahmundry", city: "RAJAHMUNDRY", distance: "1.1 km", phone: "8341325433", state: "Andhra Pradesh", zip: "533101", openStatus: true, openTime: "Closes 9:30 PM" }
    ];

    // --- Product Catalog Dataset ---
    const catalogData = [
      { id: 1, title: "Peach Mul Chanderi Suit", price: "999", oldPrice: "1,199", discount: "16% OFF", category: "Kurti Sets", tag: "New", tagColor: "", img: "file:///Users/aakrutixhob/Downloads/WEBSITE MOBILE PSOTERS-04.png", priceVal: 1000, style: "Festive" },
      { id: 2, title: "Contemporary Co-Ord Set", price: "1,450", oldPrice: "1,999", discount: "27% OFF", category: "Co-Ord Sets", tag: "Trending", tagColor: "green", img: "file:///Users/aakrutixhob/Downloads/WEBSITE MOBILE PSOTERS-01.png", priceVal: 1500, style: "Casual" },
      { id: 3, title: "Daily Comfort Lounge Wear", price: "1,299", oldPrice: "1,699", discount: "24% OFF", category: "Lounge Wear", tag: "Cotton Comfort", tagColor: "green", img: "file:///Users/aakrutixhob/Downloads/WEBSITE MOBILE PSOTERS-02.png", priceVal: 1500, style: "Daily Wear" },
      { id: 4, title: "Elegance Office Edit Gown", price: "1,999", oldPrice: "2,599", discount: "23% OFF", category: "Office Wear", tag: "Office Diva", tagColor: "", img: "file:///Users/aakrutixhob/Downloads/WEBSITE MOBILE PSOTERS-03.png", priceVal: 2000, style: "Office" },
      { id: 5, title: "Vibrant Indigo Kurta", price: "1,150", oldPrice: "1,500", discount: "23% OFF", category: "Kurtis", tag: "Daily Wear", tagColor: "green", img: "file:///Users/aakrutixhob/Downloads/WEBSITE MOBILE PSOTERS-05.png", priceVal: 1500, style: "Daily Wear" },
      { id: 6, title: "Classic Red Bandhani Set", price: "2,199", oldPrice: "2,999", discount: "26% OFF", category: "Kurti Sets", tag: "New", tagColor: "", img: "file:///Users/aakrutixhob/Downloads/WEBSITE MOBILE PSOTERS-04.png", priceVal: 2500, style: "Party" }
    ];

    // --- State Management ---
    let currentHero = 0;
    let selectedLocatorCity = 'All';

    // --- DOM Loaded ---
    window.addEventListener('DOMContentLoaded', () => {
      // Safely render catalog grid if element exists
      const grid = document.getElementById('catalogGridItems');
      if (grid) {
        renderCatalogGrid(catalogData);
      }
      
      // Safely render locator cards if element exists
      const locatorWrapper = document.getElementById('locatorCardsWrapper');
      if (locatorWrapper) {
        renderLocatorCards(locatorStores);
      }

      // Autoplay Hero banner every 5 seconds if hero exists
      const slides = document.querySelectorAll('.hero-slide');
      if (slides && slides.length > 0) {
        setInterval(() => {
          let nextHero = (currentHero + 1) % slides.length;
          setHeroSlide(nextHero);
        }, 8000);
      }
      
      // Dynamic Scroll Listener for Navigation transparency
      function checkScroll() {
        const nav = document.getElementById('mainHeaderNavbar');
        if (nav) {
          if (window.scrollY > 30) {
            nav.classList.add('scrolled');
          } else {
            nav.classList.remove('scrolled');
          }
        }
      }
      window.addEventListener('scroll', checkScroll, { passive: true });
      checkScroll();
    });


    // --- Mobile Drawer Toggle - completely disabled/not used ---
    function toggleMobileDrawer(open) {
      // Hamburger is removed, so drawer is deprecated
    }

    // --- Toast Alerts ---
    function triggerWebToast(message) {
      const toast = document.getElementById('webToast');
      if (!toast) {
        console.log("Toast:", message);
        return;
      }
      toast.textContent = message;
      toast.classList.add('show');
      setTimeout(() => {
        toast.classList.remove('show');
      }, 2000);
    }

    // --- Slide Controller ---
    function setHeroSlide(index) {
      const slides = document.querySelectorAll('.hero-slide');
      const dots = document.querySelectorAll('.hero-dot');

      slides[currentHero].classList.remove('active');
      dots[currentHero].classList.remove('active');

      currentHero = index;

      slides[currentHero].classList.add('active');
      dots[currentHero].classList.add('active');
    }

    // --- Page Section Switcher (Responsive) ---
    function switchPageTab(tabName) {
      const homePanel = document.getElementById('homePagePanel');
      const storesPanel = document.getElementById('storesPagePanel');
      
      const links = document.querySelectorAll('.nav-link');
      const mItems = document.querySelectorAll('.mobile-tab-item');
      
      // Scroll to top
      window.scrollTo({ top: 0, behavior: 'smooth' });

      links.forEach(l => {
        if (l.textContent.toLowerCase() === tabName || (tabName === 'stores' && l.textContent.toLowerCase().includes('stores')) || (tabName === 'home' && l.textContent.toLowerCase().includes('home'))) {
          l.classList.add('active');
        } else {
          l.classList.remove('active');
        }
      });

      mItems.forEach(m => {
        if (m.id.toLowerCase().includes(tabName)) {
          m.classList.add('active');
        } else {
          m.classList.remove('active');
        }
      });

      if (tabName === 'home') {
        homePanel.style.display = 'block';
        storesPanel.style.display = 'none';
      } else if (tabName === 'stores') {
        homePanel.style.display = 'none';
        storesPanel.style.display = 'block';
        triggerWebToast("Showing our 70+ retail outlets on map...");
      }
    }

    // --- Tab Selector ---
    function toggleMainTab(tabType) {
      const btns = document.querySelectorAll('.tabs-btn');
      btns.forEach(b => {
        if (b.textContent.toLowerCase().includes(tabType)) {
          b.classList.add('active');
        } else {
          b.classList.remove('active');
        }
      });

      document.getElementById('mainTabProduct').classList.toggle('active', tabType === 'product');
      document.getElementById('mainTabOccasion').classList.toggle('active', tabType === 'occasion');
      document.getElementById('mainTabBudget').classList.toggle('active', tabType === 'budget');
    }

    // --- Product filtering actions ---
    function filterCatalogCategory(catLabel) {
      let filtered = [];
      if (catLabel === 'All') {
        filtered = catalogData;
      } else {
        filtered = catalogData.filter(p => 
          p.category.toLowerCase().includes(catLabel.toLowerCase()) || 
          catLabel.toLowerCase().includes(p.category.toLowerCase()) ||
          p.style.toLowerCase().includes(catLabel.toLowerCase())
        );
      }
      
      renderCatalogGrid(filtered.length ? filtered : catalogData);
      
      // Update catalog header
      document.getElementById('catalogFeedHeader').textContent = catLabel === 'All' ? 'New Arrivals' : catLabel;

      const elem = document.getElementById('catalogCatalogSection');
      elem.scrollIntoView({ behavior: 'smooth', block: 'start' });
      triggerWebToast(`Browsing ${catLabel}...`);
    }

    function filterCatalogPrice(maxPrice) {
      const filtered = catalogData.filter(p => p.priceVal <= maxPrice);
      renderCatalogGrid(filtered);
      
      document.getElementById('catalogFeedHeader').textContent = `Products Under ₹${maxPrice}`;

      const elem = document.getElementById('catalogCatalogSection');
      elem.scrollIntoView({ behavior: 'smooth', block: 'start' });
      triggerWebToast(`Showing budget items under ₹${maxPrice}...`);
    }

    // Morphing ATC and sizes toggle (Feedback 1)
    function toggleSizeSelector(buttonElement, show) {
      const wrapper = buttonElement.closest('.catalog-atc-wrapper');
      const selector = wrapper.querySelector('.catalog-size-selector');
      if (show) {
        selector.classList.add('active');
      } else {
        selector.classList.remove('active');
      }
    }

    function addToCart(productName, size, chipElement) {
      const selector = chipElement.closest('.catalog-size-selector');
      if (selector) {
        selector.classList.remove('active');
      }
      
      const card = chipElement.closest('.catalog-card');
      if (!card) return;
      
      const qvBtn = card.querySelector('.catalog-quickview-btn');
      if (!qvBtn) {
        // Fallback for mockups if quickview button isn't present
        triggerWebToast(`Added ${productName} (Size ${size}) to cart successfully!`);
        return;
      }
      
      let productData;
      try {
        productData = JSON.parse(qvBtn.getAttribute('data-product'));
      } catch (e) {
        console.error("Failed to parse product data for ATC:", e);
        return;
      }
      
      if (!productData || !productData.variants) return;
      
      const sizeUpper = size.trim().toUpperCase();
      const matchingVariants = productData.variants.filter(v => {
        const titleUpper = v.title.trim().toUpperCase();
        if (titleUpper === sizeUpper) return true;
        const parts = titleUpper.split('/').map(p => p.trim());
        return parts.includes(sizeUpper);
      });
      
      if (matchingVariants.length === 0) {
        alert("This size is currently not available.");
        return;
      }
      
      const variant = matchingVariants.find(v => v.available) || matchingVariants[0];
      
      // If it's a mockup variant, just show toast
      if (typeof variant.id === 'string' && variant.id.startsWith('mock-')) {
        triggerWebToast(`Added ${productName} (Size ${size}) to cart successfully!`);
        return;
      }
      
      // Add to Shopify Cart via AJAX
      const formData = new FormData();
      formData.append('id', variant.id);
      formData.append('quantity', 1);
      
      const cartItemsComponents = document.querySelectorAll('cart-items-component');
      let cartItemComponentsSectionIds = [];
      cartItemsComponents.forEach((item) => {
        if (item instanceof HTMLElement && item.dataset.sectionId) {
          cartItemComponentsSectionIds.push(item.dataset.sectionId);
        }
      });
      formData.append('sections', cartItemComponentsSectionIds.join(','));
      
      const originalText = chipElement.textContent;
      chipElement.textContent = '..';
      chipElement.style.pointerEvents = 'none';
      
      const fetchUrl = window.Theme?.routes?.cart_add_url || '/cart/add.js';
      
      fetch(fetchUrl, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'text/html'
        }
      })
      .then(res => res.json())
      .then(data => {
        chipElement.textContent = originalText;
        chipElement.style.pointerEvents = 'auto';
        
        if (data.status) {
          alert(data.description || data.message || 'Error adding to cart.');
        } else {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: {},
              sourceId: variant.id.toString(),
              data: {
                itemCount: 1,
                sections: data.sections,
                source: 'product-form-component'
              }
            }
          }));
          
          // Open slide-out cart drawer
          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          }
        }
      })
      .catch(err => {
        console.error(err);
        chipElement.textContent = originalText;
        chipElement.style.pointerEvents = 'auto';
      });
    }

    function renderCatalogGrid(products) {
      const grid = document.getElementById('catalogGridItems');
      grid.innerHTML = '';

      if (!products.length) {
        grid.innerHTML = `<div style="font-size: 13px; color: var(--soft-grey); padding: 40px; text-align: center; grid-column: 1/-1;">No products found matching this filter.</div>`;
        return;
      }

      products.forEach(p => {
        const tag = p.tag ? `<div class="catalog-tag ${p.tagColor}">${p.tag}</div>` : '';
        const oldPrice = p.oldPrice ? `<s>₹${p.oldPrice}</s>` : '';
        const discountTag = p.discount ? `<span class="catalog-discount">${p.discount}</span>` : '';

        const card = `
          <div class="catalog-card">
            <div class="catalog-card-img-box">
              <img src="${p.img}" alt="${p.title}">
              ${tag}
              <div class="catalog-wishlist-btn" onclick="wishlistToggle(this, event)">
                <i class="fa-regular fa-heart"></i>
              </div>
            </div>
            <div class="catalog-info">
              <div class="catalog-title">${p.title}</div>
              <div class="catalog-price">₹${p.price} ${oldPrice} ${discountTag}</div>
            </div>
            <div class="catalog-atc-wrapper">
              <button class="catalog-atc-btn" onclick="toggleSizeSelector(this, true)">
                <i class="fa-solid fa-bag-shopping"></i> Add to cart
              </button>
              <div class="catalog-size-selector">
                <span class="size-chip" onclick="addToCart('${p.title}', 'S', this)">S</span>
                <span class="size-chip" onclick="addToCart('${p.title}', 'M', this)">M</span>
                <span class="size-chip" onclick="addToCart('${p.title}', 'L', this)">L</span>
                <span class="size-chip" onclick="addToCart('${p.title}', 'XL', this)">XL</span>
                <i class="fa-solid fa-xmark size-selector-close" onclick="toggleSizeSelector(this, false)"></i>
              </div>
            </div>
          </div>
        `;
        grid.insertAdjacentHTML('beforeend', card);
      });
    }

    function wishlistToggle(element, event) {
      event.stopPropagation();
      let handle = element.getAttribute('data-wishlist-handle');
      if (!handle) {
        const card = element.closest('.catalog-card');
        if (card) {
          const titleEl = card.querySelector('.catalog-title');
          if (titleEl) {
            const title = titleEl.textContent.trim();
            handle = title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '');
          }
        }
      }
      if (!handle) return;
      if (window.aakrutiWishlist) {
        window.aakrutiWishlist.toggle(handle);
        if (window.aakrutiWishlist.isIn(handle)) {
          triggerWebToast("Added to your wishlist!");
        } else {
          triggerWebToast("Removed from wishlist.");
        }
      }
    }

    // --- Shoppable Video Reels Controllers ---
    function toggleReelPlay(cardElement) {
      const video = cardElement.querySelector('.reel-video');
      if (cardElement.querySelector('.reel-shop-popover').classList.contains('active')) {
        return;
      }
      if (video.paused) {
        video.play();
        triggerWebToast("Resumed reel video...");
      } else {
        video.pause();
        triggerWebToast("Paused reel video");
      }
    }

    function toggleReelSound(btnElement, event) {
      event.stopPropagation();
      const card = btnElement.closest('.reel-card');
      const video = card.querySelector('.reel-video');
      const icon = btnElement.querySelector('i');
      
      if (video.muted) {
        video.muted = false;
        icon.classList.remove('fa-volume-xmark');
        icon.classList.add('fa-volume-high');
        triggerWebToast("Audio unmuted!");
      } else {
        video.muted = true;
        icon.classList.remove('fa-volume-high');
        icon.classList.add('fa-volume-xmark');
        triggerWebToast("Audio muted");
      }
    }

    function openReelPopover(id, event) {
      event.stopPropagation();
      const popover = document.getElementById(`reelPopover${id}`);
      popover.classList.add('active');
      triggerWebToast("Explore featured outfits in this reel!");
    }

    function closeReelPopover(id, event) {
      event.stopPropagation();
      const popover = document.getElementById(`reelPopover${id}`);
      popover.classList.remove('active');
    }

    // --- Store Locator Engine ---
    function locatorFilterCity(cityName) {
      selectedLocatorCity = cityName;

      const chips = document.querySelectorAll('.locator-city-chip');
      chips.forEach(c => {
        if (c.textContent.toUpperCase().includes(cityName.toUpperCase()) || (cityName === 'All' && c.textContent.includes('All'))) {
          c.classList.add('active');
        } else {
          c.classList.remove('active');
        }
      });

      let filtered = locatorStores;
      if (cityName !== 'All') {
        filtered = locatorStores.filter(s => s.city.toUpperCase() === cityName.toUpperCase());
      }
      renderLocatorCards(filtered);

      const pins = document.querySelectorAll('.map-locator-pin');
      pins.forEach(p => p.classList.remove('active'));

      if (cityName === 'HYDERABAD') document.getElementById('pin-hyd').classList.add('active');
      if (cityName === 'KHAMMAM') document.getElementById('pin-kmm').classList.add('active');
      if (cityName === 'VIJAYAWADA') document.getElementById('pin-vjw').classList.add('active');
      if (cityName === 'WARANGAL') document.getElementById('pin-wgl').classList.add('active');
      if (cityName === 'NELLORE') document.getElementById('pin-nel').classList.add('active');
      if (cityName === 'RAJAHMUNDRY') document.getElementById('pin-rjy').classList.add('active');
    }

    function locatorFilterText() {
      const text = document.getElementById('locatorInputBox').value.toLowerCase().trim();
      if (!text) {
        locatorFilterCity('All');
        return;
      }

      const filtered = locatorStores.filter(s => 
        s.name.toLowerCase().includes(text) || 
        s.address.toLowerCase().includes(text) || 
        s.city.toLowerCase().includes(text) || 
        s.state.toLowerCase().includes(text) || 
        s.zip.toLowerCase().includes(text)
      );
      renderLocatorCards(filtered);
    }

    function highlightStoreCard(storeName) {
      const cards = document.querySelectorAll('.store-feed-card');
      cards.forEach(c => {
        const name = c.querySelector('.store-feed-name').textContent;
        if (name === storeName) {
          c.classList.add('highlight');
          c.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          setTimeout(() => c.classList.remove('highlight'), 3000);
        } else {
          c.classList.remove('highlight');
        }
      });
    }

    function renderLocatorCards(stores) {
      const container = document.getElementById('locatorCardsWrapper');
      container.innerHTML = '';

      if (!stores.length) {
        container.innerHTML = `<div style="font-size: 11px; text-align: center; padding: 40px; color: var(--soft-grey)">No matching outlets found.</div>`;
        return;
      }

      stores.forEach(s => {
        const statusHtml = s.openStatus 
          ? `<span class="store-feed-status open"><i class="fa-solid fa-circle"></i> Open · ${s.openTime}</span>`
          : `<span class="store-feed-status closed"><i class="fa-solid fa-circle"></i> Closed · ${s.openTime}</span>`;

        const mapsLink = `https://www.google.com/maps?q=${encodeURIComponent(s.name + ", " + s.address)}`;
        const waLink = `https://wa.me/918341325433?text=${encodeURIComponent("Hello! I am checking stock for " + s.name + ".")}`;

        const card = `
          <div class="store-feed-card" onclick="highlightStoreCard('${s.name}')">
            <div class="store-feed-header">
              <span class="store-feed-name">${s.name}</span>
              <span class="store-feed-distance">${s.distance}</span>
            </div>
            <div class="store-feed-address">${s.address}, ${s.city}, ${s.state} - ${s.zip}</div>
            ${statusHtml}
            <div class="store-feed-ctas">
              <a href="tel:${s.phone}" class="store-feed-btn"><i class="fa-solid fa-phone"></i> Call</a>
              <a href="${mapsLink}" target="_blank" class="store-feed-btn"><i class="fa-solid fa-diamond-turn-right"></i> Directions</a>
              <a href="${waLink}" target="_blank" class="store-feed-btn whatsapp" onclick="event.stopPropagation()"><i class="fa-brands fa-whatsapp"></i> Check Stock</a>
            </div>
          </div>
        `;
        container.insertAdjacentHTML('beforeend', card);
      });
    }

    // Expose functions globally for inline HTML event handlers
    window.wishlistToggle = wishlistToggle;
    window.toggleSizeSelector = toggleSizeSelector;
    window.addToCart = addToCart;
    window.highlightStoreCard = highlightStoreCard;
    window.locatorFilterCity = locatorFilterCity;
    window.locatorFilterText = locatorFilterText;
    window.toggleMobileDrawer = toggleMobileDrawer;
    window.triggerWebToast = triggerWebToast;
    window.setHeroSlide = setHeroSlide;
    window.switchPageTab = switchPageTab;
    window.toggleMainTab = toggleMainTab;
    window.filterCatalogCategory = filterCatalogCategory;
    window.filterCatalogPrice = filterCatalogPrice;
    window.toggleReelPlay = toggleReelPlay;
    window.toggleReelSound = toggleReelSound;
    window.openReelPopover = openReelPopover;
    window.closeReelPopover = closeReelPopover;
  